export enum DETAILED_RESULTS_FAD_FLEX {
  WORST_POINT_DAMAGE = 'WORST_POINT_DAMAGE',
  WORST_POINT_STRESSES = 'WORST_POINT_STRESSES',
  WORST_POINT_HISTOGRAM = 'WORST_POINT_HISTOGRAM',
  ALL_POINTS_DAMAGE = 'ALL_POINTS_DAMAGE',
  NONE = 'NONE',
}
